import type { ReactNode } from 'react';

import { Suspense } from '@sorare/core/src/atoms/Suspense';
import { LoadingIndicator } from '@sorare/core/src/atoms/loader/LoadingIndicator';
import { lazy } from '@sorare/core/src/lib/retry';

const BlockchainProviders = lazy(
  async () => import('./index.tsx'),
  'BlockchainProviders'
);

export const LazyBlockchainProviders = ({
  children,
}: {
  children: ReactNode;
}) => {
  return (
    <Suspense fallback={<LoadingIndicator fullScreen />}>
      <BlockchainProviders>{children}</BlockchainProviders>
    </Suspense>
  );
};
